import { render } from "./ForgotPasswordTokenForm.vue?vue&type=template&id=5230a264"
import script from "./ForgotPasswordTokenForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordTokenForm.vue?vue&type=script&lang=js"
script.render = render

export default script